package dev.lingvo.shared.screenshots

import dev.lingvo.shared.screenshots.color.IconPaletteExtractor
import dev.lingvo.shared.screenshots.color.IconPalettes
import dev.lingvo.shared.screenshots.color.PaletteDeriver
import dev.lingvo.shared.screenshots.color.Palettes
import dev.lingvo.shared.screenshots.doc.Board
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.doc.TemplateId
import dev.lingvo.shared.screenshots.geom.Rect
import dev.lingvo.shared.screenshots.geom.safeArea as boardSafeArea
import dev.lingvo.shared.screenshots.scene.SceneArranger
import dev.lingvo.shared.screenshots.scene.Scenes
import dev.lingvo.shared.screenshots.templates.LaunchLayouts
import dev.lingvo.shared.screenshots.templates.LaunchTemplates
import dev.lingvo.shared.screenshots.templates.Template
import dev.lingvo.shared.screenshots.templates.TemplateCatalog

/** One entry point keeps template picking, brand derivation and editor scene changes consistent across clients. */
object ScreenshotLooks : TemplateCatalog {
    /** Layouts lead the first-run picker before the expressive recipe collection. */
    override val all: List<Template> = LaunchLayouts.all + LaunchTemplates.all
    /** Stable launch order matches caption-above, caption-below and caption-over controls. */
    override val launchLayouts: List<Template> = LaunchLayouts.all
    /** Geometry-only scene switching preserves translated strings and captured screenshots. */
    val scenes: SceneArranger = Scenes
    /** Shared perceptual derivation avoids platform-specific colour differences. */
    val palettes: PaletteDeriver = Palettes
    /** Icon analysis uses ordinary RGBA bytes on both Kotlin targets. */
    val iconPalettes: IconPaletteExtractor = IconPalettes

    /** Unknown ids remain unknown rather than silently choosing a different saved design. */
    override fun byId(id: TemplateId): Template? = all.firstOrNull { it.id == id }

    /** Lets frontends query caption-safe bounds without duplicating frame-specific rules. */
    fun safeArea(board: Board, frameHint: FrameKind? = null): Rect = boardSafeArea(board, frameHint)
}
